module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-hub-dashboard"
  }, [_c('dashboard-header'), _vm._v(" "), _c('audience-hub-table', {
    attrs: {
      "filters": _vm.query,
      "routeParamsName": _vm.routeParamsName
    },
    on: {
      "targetOption": _vm.handleTargetOption
    }
  }), _vm._v(" "), _c('div', [_c('dashboard-action-modal', {
    ref: "deleteModal",
    attrs: {
      "target": _vm.activeTarget,
      "buttonText": "Delete"
    },
    on: {
      "click": _vm.deleteTarget
    }
  }, [_vm._v("\n      Are you sure you want to delete target "), _c('span', {
    staticClass: "audience-hub-dashboard__delete-target-name"
  }, [_vm._v(_vm._s(_vm.activeTarget.display_name) + "?")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4017f956"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/audienceHub/AudienceHubDashboard.vue
// module id = 2456
// module chunks = 0